import { userInteraction } from "@eusoft/webapp-framework";
import { EmptyView } from "@eusoft/webapp-framework/components/EmptyView";
import { Style, forModel } from "@eusoft/webapp-jsx";
import { Action, Content, contentInfo, formatText, stringOrUndef } from "@eusoft/webapp-ui";
import { navigatePage, navigatePageForResult } from "../actions/Common";
import { UserAccountType, type ISaleCircuitListView } from "../entities/Commands";
import { Icons } from "../entities/Icons";
import { BusinessNavigation, type INavigationEntry } from "../entities/Navigation";
import { Authorize } from "../services/Authorize";
import { executeCacheAsync } from "../services/DataService";
import { userSession } from "../services/UserSession";
import type { IEditSaleCircuit } from "./saleCircuit/EditSaleCircuit";
import "./HomePage.scss";
import type { IContextInfo } from "../components/ContextView";
import { registerComponent } from "@eusoft/webapp-core/Component";


function EmptyCircuit() {

    const createSaleCircuit = async () => {

        const result = (await navigatePageForResult("sale-circuit-create")) as IEditSaleCircuit;

        if (!result)
            return;

        const insert = await userInteraction.confirmAsync("msg-insert-sale-point", "");

        if (insert)
            await navigatePage("sale-point-create", { saleCircuitId: result.id })

    };

    return <EmptyView
        iconName="point_of_sale"
        addLabel="create-now"
        message="msg-no-sale-circuit"
        addAction={() => createSaleCircuit()}
    />
}

function NavList(options: { src: INavigationEntry[] }) {

    return <div className="nav-list">
        {options.src.forEach(a => <div visible={!a.isVisible || a.isVisible()} on-click={() => a.action()}>
            <Style backgroundColor={a.color} />
            <div className="icon">{a.icon}</div>
            <div className="body">
                <label>{formatText(a.name)}</label>
                <div>{formatText("desc-" + a.name)}</div>
            </div>
        </div>)}
    </div>
}

function NavBox(options: { src: INavigationEntry[] }) {

    return <div className="nav-box">
        {options.src.forEach(a => <Action
            visible={!a.isVisible || a.isVisible()}
            color={a.color}
            name={stringOrUndef(a.name)}
            onExecuteAsync={() => a.action()}>
            {[a.icon, formatText(a.name)]}
        </Action>)}
    </div>
}

export interface IHomePageArgs {

    navRoot?: INavigationEntry;   
}

export class HomePage extends Content<IHomePageArgs> implements IContextInfo  {
    constructor() {

        super();

        this.init(HomePage, {
            style: ["panel"],
            body: forModel(this, m => <>
                {m.navRoot?.navMode == "list" && <NavList src={m.navRoot?.children} />}
                {m.navRoot?.navMode == "box" && <NavBox src={m.navRoot?.children} />}
                {!m.navRoot && m.isBusiness  && <EmptyCircuit />}
                {/*<button on-click={() => testLayout()}>Layout</button>*/}
            </>) 
        });
    }

    

    override async onLoadAsync(args: IHomePageArgs) {

        if (args.navRoot) {
            this.navRoot = args.navRoot;
        }
        else {
            if (this.isBusiness) {

                this.saleCircuits = (await executeCacheAsync("ListSaleCircuit")).items;

                if (this.saleCircuits.length > 0) {

                    this.navRoot = {
                        children: BusinessNavigation,
                        navMode: "box",
                        name: "home"
                    }
                }
                else
                    this.hideContext = true;
            }
        }

        this.title = this.navRoot?.name ?? "home";

        return true;
    }

    get isBusiness() {
        return userSession.active?.user?.accountType == UserAccountType.Business;
    }

    navRoot: INavigationEntry;

    saleCircuits: ISaleCircuitListView[];

    hideContext: boolean;

    static override info = contentInfo({
        name: "home",
        route: "/",
        icon: Icons["home"],
        features: [Authorize()],
        factory: () => new HomePage()
    });
}

registerComponent(HomePage, "HomePage");
